/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Card, CardContent, Slider } from "@repo/ui";
import React from "react";
import { Link } from "react-router-dom";

interface ProgressBarChartProps {
  title: string;
  value: number;
  valueString: string;
  totalString: string;
  count?: number;
  disabledNavigation?: boolean;
  filters?: {
    date?: { id: string };
    status?: string;
    assignmentGroups?: string[];
    activityTypes?: string[];
    customers?: string[];
    sourceDashboard?: string;
  };
  eventType?: "Response" | "Resolution"; // mandatory for details page
}

export default function ProgressBarChart({
  title,
  value,
  valueString,
  totalString,
  count,
  disabledNavigation,
  filters,
  eventType = "Response", // default to Response
}: ProgressBarChartProps) {
  const nf = Intl.NumberFormat();

  const sliderValue = count && count > 0 ? (value / count) * 100 : 0;

  /** Build query params */
  const queryParams = new URLSearchParams({
    type: "aboutToBreach",
    title,
    period: filters?.date?.id || "all",
    status: filters?.status || "",
    assignmentGroup: (filters?.assignmentGroups || []).join(","),
    activityType: (filters?.activityTypes || []).join(","),
    customerId: (filters?.customers || []).join(","),
    sourceDashboard: filters?.sourceDashboard || "",
    pageNumber: "1",
    pageRowCount: "100",
    searchCriteria: "",
    eventCategory: "SLA",
    eventType,
    isBreached: "false",
    isAboutToBreach: "true",
  });

  return (
    <Card>
      <Link
        to={
          disabledNavigation
            ? ""
            : `/sla-dashboard-detail?${queryParams.toString()}`
        }
      >
        <CardContent className="p-4">
          <h3 className="font-semibold text-lg">{title}</h3>

          <div className="grid grid-cols-[max-content_max-content] justify-between mt-3 gap-3">
            <span>{`${valueString}: ${nf.format(value)}`}</span>

            <span>{`${totalString}: ${nf.format(count || 0)}`}</span>

            <Slider
              className="col-span-2 [&_[data-orientation=horizontal]>.bg-primary]:bg-[#60db87] [&_.bg-primary]:bg-[#60db87]"
              value={[sliderValue]}
              max={100}
              step={1}
              disabled
            />
            <span className="text-sm">{Math.round(sliderValue)}%</span>
          </div>
        </CardContent>
      </Link>
    </Card>
  );
}
